import { useState } from 'react';
import { useCouponListQuery } from '../../../hooks/queries/coupon/useCouponListQuery';
import { CouponListFilterOption, CouponListItem } from '../../../types/coupons/list-v2';
import { ALIMTALK_PICKER_PAGE_SIZE } from './constants';
import { PickerModal } from './PickerModal';

export type PickedCoupon = {
  couponId: number;
  name: string;
  // 표시 파생용 (DTO 미전송) — 만료 미리보기 유효기간·발급 유효기간 힌트는 쿠폰 자체 정보에서 가져온다.
  // periodType은 V1 숫자 코드(COUPON_PERIOD_TYPE): 0=날짜 지정(start/end) / 1=발급일+dayPlus일 / 2=무기한
  periodType: number;
  startDate: string | null;
  endDate: string | null;
  dayPlus: number | null;
};

export type CouponPickerModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (coupons: PickedCoupon[]) => void;
};

const buildFilterOption = (name: string): CouponListFilterOption => ({
  couponId: null,
  name: name || null,
  description: null,
  status: null,
  isDownloadable: 0,
  availableType: null,
  discountType: null,
  code: null,
  createDate: { startDate: null, endDate: null },
});

export const CouponPickerModal = (props: CouponPickerModalProps) => {
  const { open, onClose, onConfirm } = props;
  const [search, setSearch] = useState('');

  const { data } = useCouponListQuery(
    { page: 0, pageSize: ALIMTALK_PICKER_PAGE_SIZE, filterOption: buildFilterOption(search) },
    { enabled: open },
  );
  const couponList: CouponListItem[] = data?.list ?? [];

  return (
    <PickerModal<CouponListItem>
      open={open}
      title="쿠폰 선택"
      searchPlaceholder="쿠폰명 검색"
      emptyText="쿠폰이 없습니다."
      mode="multi"
      items={couponList}
      getId={(item) => item.id}
      getLabel={(item) => item.name}
      onSearch={setSearch}
      onClose={onClose}
      onConfirm={(items) =>
        onConfirm(
          items.map((item) => ({
            couponId: item.id,
            name: item.name,
            // CouponListItem 타입 선언(string)과 달리 실 V1 응답은 숫자 코드 — 숫자로 정규화
            periodType: Number(item.periodType),
            startDate: item.startDate,
            endDate: item.endDate,
            dayPlus: item.dayPlus,
          })),
        )
      }
    />
  );
};
